module.exports = __webpack_public_path__ + "78fe5012.png";